var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 15.1666C4.04732 15.1666 0.833984 11.9533 0.833984 7.99992C0.833984 4.04659 4.04732 0.833252 8.00065 0.833252C11.954 0.833252 15.1673 4.04659 15.1673 7.99992C15.1673 11.9533 11.954 15.1666 8.00065 15.1666ZM8.00065 1.83325C4.60065 1.83325 1.83398 4.59992 1.83398 7.99992C1.83398 11.3999 4.60065 14.1666 8.00065 14.1666C11.4007 14.1666 14.1673 11.3999 14.1673 7.99992C14.1673 4.59992 11.4007 1.83325 8.00065 1.83325Z",
    fill: "#E60A2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16044 10.8534C7.03378 10.8534 6.90711 10.8068 6.80711 10.7068C6.61378 10.5134 6.61378 10.1934 6.80711 10.0001L8.80711 8.0001L6.80711 6.0001C6.61378 5.80677 6.61378 5.48677 6.80711 5.29344C7.00044 5.1001 7.32044 5.1001 7.51378 5.29344L9.86711 7.64677C10.0604 7.8401 10.0604 8.1601 9.86711 8.35344L7.51378 10.7068C7.41378 10.8068 7.28711 10.8534 7.16044 10.8534Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.77081b0196fef92ddcfad189120b371c.svg";
export { ForwardRef as ReactComponent };